export const CacheActionTypes = {
    SET_CACHE_RESPONSE: 'SET_CACHE_RESPONSE',
    RESET_CACHE: 'RESET_CACHE',
}
